/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Technologies_Servicedescription1Inputs */

const en_us2_technologies_servicedescription1 = /** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The profile service could not respond, but matching games are still available below.`)
};

const es_es2_technologies_servicedescription1 = /** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El servicio de perfiles no ha respondido, pero puedes consultar los juegos relacionados más abajo.`)
};

const ru_technologies_servicedescription1 = /** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сервис профилей не ответил, но подходящие игры по-прежнему доступны ниже.`)
};

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const id_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const ms_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const da_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const de_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const es_mx2_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const fil_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const fr_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const it_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const hu_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const nl_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const no_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const pl_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const pt_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const pt_br2_technologies_servicedescription1 = pt_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const ro_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const fi_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const sv_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const vi_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const tr_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const cs_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const bg_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const uk_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const ar_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const hi_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const th_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const ja_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const zh_cn2_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const zh_hant1_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/** @type {(inputs: Technologies_Servicedescription1Inputs) => LocalizedString} */
const ko_technologies_servicedescription1 = en_us2_technologies_servicedescription1;

/**
* | output |
* | --- |
* | "The profile service could not respond, but matching games are still available below." |
*
* @param {Technologies_Servicedescription1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const technologies_servicedescription1 = /** @type {((inputs?: Technologies_Servicedescription1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Technologies_Servicedescription1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_technologies_servicedescription1(inputs)
	if (locale === "ms") return ms_technologies_servicedescription1(inputs)
	if (locale === "da") return da_technologies_servicedescription1(inputs)
	if (locale === "de") return de_technologies_servicedescription1(inputs)
	if (locale === "en-US") return en_us2_technologies_servicedescription1(inputs)
	if (locale === "es-ES") return es_es2_technologies_servicedescription1(inputs)
	if (locale === "es-MX") return es_mx2_technologies_servicedescription1(inputs)
	if (locale === "fil") return fil_technologies_servicedescription1(inputs)
	if (locale === "fr") return fr_technologies_servicedescription1(inputs)
	if (locale === "it") return it_technologies_servicedescription1(inputs)
	if (locale === "hu") return hu_technologies_servicedescription1(inputs)
	if (locale === "nl") return nl_technologies_servicedescription1(inputs)
	if (locale === "no") return no_technologies_servicedescription1(inputs)
	if (locale === "pl") return pl_technologies_servicedescription1(inputs)
	if (locale === "pt-BR") return pt_br2_technologies_servicedescription1(inputs)
	if (locale === "pt") return pt_technologies_servicedescription1(inputs)
	if (locale === "ro") return ro_technologies_servicedescription1(inputs)
	if (locale === "fi") return fi_technologies_servicedescription1(inputs)
	if (locale === "sv") return sv_technologies_servicedescription1(inputs)
	if (locale === "vi") return vi_technologies_servicedescription1(inputs)
	if (locale === "tr") return tr_technologies_servicedescription1(inputs)
	if (locale === "cs") return cs_technologies_servicedescription1(inputs)
	if (locale === "bg") return bg_technologies_servicedescription1(inputs)
	if (locale === "ru") return ru_technologies_servicedescription1(inputs)
	if (locale === "uk") return uk_technologies_servicedescription1(inputs)
	if (locale === "ar") return ar_technologies_servicedescription1(inputs)
	if (locale === "hi") return hi_technologies_servicedescription1(inputs)
	if (locale === "th") return th_technologies_servicedescription1(inputs)
	if (locale === "ja") return ja_technologies_servicedescription1(inputs)
	if (locale === "zh-CN") return zh_cn2_technologies_servicedescription1(inputs)
	if (locale === "zh-Hant") return zh_hant1_technologies_servicedescription1(inputs)
	return ko_technologies_servicedescription1(inputs)
});
export { technologies_servicedescription1 as "technologies.serviceDescription" }